function shopify_surface_pick_up_dist_index_es_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function dist_index_es_defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function dist_index_es_createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        dist_index_es_defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        dist_index_es_defineProperties(Constructor, staticProps);
    return Constructor;
}
var LOCAL_STORAGE_KEY = 'pxu-shopify-surface-pick-up';
var loadingClass = 'surface-pick-up--loading';
var isNotExpired = function isNotExpired(timestamp) {
    return timestamp + 1000 * 60 * 60 <= Date.now();
};
var removeTrailingSlash = function removeTrailingSlash(s) {
    return s.replace(/(.*)\/$/, '$1');
}; // Haversine Distance
// The haversine formula is an equation giving great-circle distances between
// two points on a sphere from their longitudes and latitudes
var calculateDistance = function calculateDistance(latitude1, longitude1, latitude2, longitude2, unitSystem) {
    var dtor = Math.PI / 180;
    var radius = unitSystem === 'metric' ? 6378.14 : 3959;
    var rlat1 = latitude1 * dtor;
    var rlong1 = longitude1 * dtor;
    var rlat2 = latitude2 * dtor;
    var rlong2 = longitude2 * dtor;
    var dlon = rlong1 - rlong2;
    var dlat = rlat1 - rlat2;
    var a = Math.pow(Math.sin(dlat / 2), 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(dlon / 2), 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return radius * c;
};
var getGeoLocation = function getGeoLocation() {
    return new Promise(function (resolve, reject) {
        var options = {
            maximumAge: 3600000,
            // 1 hour
            timeout: 5000,
        };
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (_ref) {
                var coords = _ref.coords;
                return resolve(coords);
            }, reject, options);
        }
        else {
            reject();
        }
    });
};
var index_es_location = null;
var setLocation = function setLocation(_ref2) {
    var latitude = _ref2.latitude, longitude = _ref2.longitude;
    return new Promise(function (resolve) {
        var cachedLocation = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
        var newData = {
            latitude: latitude,
            longitude: longitude,
            timestamp: Date.now(),
        };
        index_es_location = newData;
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newData));
        if (cachedLocation !== null &&
            cachedLocation.latitude === latitude &&
            cachedLocation.longitude === longitude && // Valid for 1 hour - per Debut's example
            isNotExpired(cachedLocation.timestamp)) {
            resolve({
                latitude: latitude,
                longitude: longitude,
            });
            return;
        }
        fetch('/localization.json', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                latitude: latitude,
                longitude: longitude,
            }),
        }).then(function () {
            return resolve({
                latitude: latitude,
                longitude: longitude,
            });
        });
    });
};
var getLocation = function getLocation() {
    return new Promise(function (resolve) {
        if (index_es_location && isNotExpired(index_es_location.timestamp)) {
            resolve(index_es_location);
            return;
        }
        resolve(getGeoLocation().then(setLocation));
    });
};
var SurfacePickUp = (function () {
    function SurfacePickUp(el, options = {}) {
        shopify_surface_pick_up_dist_index_es_classCallCheck(this, SurfacePickUp);
        this.el = el;
        this.options = Object.assign({ root_url: (globalThis.Theme && globalThis.Theme.routes && globalThis.Theme.routes.root_url) || '' }, options);
        this.options.root_url = removeTrailingSlash(this.options.root_url);
        this.callbacks = [];
        this.onBtnPress = null;
        this.latestVariantId = null;
        this.pickUpEnabled = localStorage.getItem(LOCAL_STORAGE_KEY) !== null;
    }
    dist_index_es_createClass(SurfacePickUp, [
        {
            key: 'load',
            value: function load(variantId) {
                var _this = this;
                // Because Shopify doesn't expose any `pick_up_enabled` data on the shop object, we
                // don't know if the variant might be, or is definitely not available for pick up.
                // Until we know the shop has > 0 pick up locations, we want to avoid prompting the
                // user for location data (it's annoying, and only makes sense to do if we use it).
                //
                // Instead, we have to make an initial request, check and see if any pick up locations
                // were returned, then ask for the users location, then make another request to get the
                // location-aware pick up locations.
                //
                // As far as I can tell the pick up aware locations differ only in sort order - which
                // we could do on the front end - but we're following this approach to ensure future
                // compatibility with any changes Shopify makes (maybe disabling options based on
                // user location, or whatever else).
                //
                // Shopify has indicated they will look into adding pick_up_enabled data to the shop
                // object, which which case this method can be greatly simplifed into 2 simple cases.
                this.latestVariantId = variantId;
                var getLocationThenInjectData = function getLocationThenInjectData() {
                    return getLocation() // If we get a location, inject data using that location
                        .then(function (coords) {
                        return _this._getData(variantId).then(function (data) {
                            return _this._injectData(data, coords);
                        });
                    }) // Otherwise, inject data without location
                    ['catch'](function () {
                        return _this._getData(variantId).then(function (data) {
                            return _this._injectData(data, null);
                        });
                    });
                };
                if (this.el) {
                    this.el.classList.add(loadingClass); // If we've previously seen some pick up locations we know this variant may be available
                }
                // for pick up, so we request browser location data.
                if (this.pickUpEnabled) {
                    return getLocationThenInjectData();
                }
                return this._getData(variantId).then(function (data) {
                    if (data.items.length > 0) {
                        _this.pickUpEnabled = true; // Inject initial data - the store displayed may not be the closest, since it was
                        // determined by IP geolocation, instead of browser side location. But better
                        // than nothing.
                        _this._injectData(data, null); // Then get browser location and go through the process again with the new location
                        // data. Any subsequent variants will skip the initial request and go
                        // directly to the browser based location data.
                        return getLocationThenInjectData();
                    } // If there are no items (pick up locations), just inject the (empty) data and return.
                    // We will continue to check for pick up locations on any new variants, since depending
                    // on product availability, the first product may have no pick up locations even if the
                    // store does have some.
                    return _this._injectData(data, null);
                });
            },
        },
        {
            key: 'onModalRequest',
            value: function onModalRequest(callback) {
                if (this.callbacks.indexOf(callback) >= 0)
                    return;
                this.callbacks.push(callback);
            },
        },
        {
            key: 'offModalRequest',
            value: function offModalRequest(callback) {
                this.callbacks.splice(this.callbacks.indexOf(callback));
            },
        },
        {
            key: 'unload',
            value: function unload() {
                this.callbacks = [];
                this.el.innerHTML = '';
            },
        },
        {
            key: '_getData',
            value: function _getData(variantId) {
                var _this2 = this;
                return new Promise(function (resolve) {
                    var xhr = new XMLHttpRequest();
                    var requestUrl = ''.concat(_this2.options.root_url, '/variants/').concat(variantId, '/?section_id=surface-pick-up');
                    xhr.open('GET', requestUrl, true);
                    xhr.onload = function () {
                        var el = xhr.response;
                        var embed = el.querySelector('[data-html="surface-pick-up-embed"]');
                        var itemsContainer = el.querySelector('[data-html="surface-pick-up-items"]');
                        var items = itemsContainer.content.querySelectorAll('[data-surface-pick-up-item]');
                        resolve({
                            embed: embed,
                            itemsContainer: itemsContainer,
                            items: items,
                            variantId: variantId,
                        });
                    };
                    xhr.onerror = function () {
                        resolve({
                            embed: {
                                innerHTML: '',
                            },
                            itemsContainer: {
                                innerHTML: '',
                            },
                            items: [],
                            variantId: variantId,
                        });
                    };
                    xhr.responseType = 'document';
                    xhr.send();
                });
            },
        },
        {
            key: '_injectData',
            value: function _injectData(_ref3, userCoords) {
                return null;
                var _this3 = this;
                var embed = _ref3.embed, itemsContainer = _ref3.itemsContainer, items = _ref3.items, variantId = _ref3.variantId;
                if (variantId !== this.latestVariantId) {
                    return null;
                }
                this.el.innerHTML = embed.innerHTML;
                this.el.classList.remove(loadingClass);
                if (items.length === 0) {
                    return this.el;
                }
                var processedDistances = false;
                var processDistances = function processDistances() {
                    if (processedDistances)
                        return;
                    processedDistances = true;
                    items.forEach(function (item) {
                        var distanceEl = item.querySelector('[data-distance]');
                        var distanceUnitEl = item.querySelector('[data-distance-unit]');
                        var unitSystem = distanceUnitEl.dataset.distanceUnit;
                        var itemLatitude = parseFloat(distanceEl.dataset.latitude);
                        var itemLongitude = parseFloat(distanceEl.dataset.longitude);
                        if (userCoords && isFinite(itemLatitude) && isFinite(itemLongitude)) {
                            var distance = calculateDistance(userCoords.latitude, userCoords.longitude, itemLatitude, itemLongitude, unitSystem);
                            distanceEl.innerHTML = distance.toFixed(1);
                        }
                        else {
                            distanceEl.remove();
                            distanceUnitEl.remove();
                        }
                    });
                };
                this.el.querySelector('[data-surface-pick-up-embed-modal-btn]').addEventListener('click', function () {
                    processDistances();
                    _this3.callbacks.forEach(function (callback) {
                        return callback(itemsContainer.innerHTML);
                    });
                });
                return this.el;
            },
        },
    ]);
    return SurfacePickUp;
})();
export default SurfacePickUp;
